export default function() {
  return new Worker(__webpack_public_path__ + "static/js/ww.3926ab3e.worker.js");
}
